import React from 'react';

const UebertragungsberechtigteForm = ({ uebertragungsberechtigte, handleUebertragungsberechtigtenChange, errors, renderFieldErrors }) => {
  const ub = uebertragungsberechtigte[0];

  return (
    <div className="form-section">
      <h3 className="section-title">Übertragungsberechtigte</h3>

      <div className="form-row">
        <div className="form-field full-width">
          <label htmlFor="uebertragungsberechtigte-name">Name <span className="required-star">*</span></label>
          <input
            id="uebertragungsberechtigte-name"
            type="text"
            value={ub.name}
            onChange={(e) => handleUebertragungsberechtigtenChange(ub.id, 'name', e.target.value)}
            className={errors.ubName ? 'error' : ''}
            placeholder=""
            title="Paderborner Hypothekenbank eG"
            maxLength={100}
          />
          {renderFieldErrors('ubName')}
        </div>
      </div>

      <div className="form-row long-short">
        <div className="form-field">
          <label htmlFor="uebertragungsberechtigte-strasse">Straße <span className="required-star">*</span></label>
          <input
            id="uebertragungsberechtigte-strasse"
            type="text"
            value={ub.strasse}
            onChange={(e) => handleUebertragungsberechtigtenChange(ub.id, 'strasse', e.target.value)}
            className={errors.ubStrasse ? 'error' : ''}
            placeholder=""
            title="Fasanenweg"
            maxLength={100}
          />
          {renderFieldErrors('ubStrasse')}
        </div>
        <div className="form-field">
          <label htmlFor="uebertragungsberechtigte-hausnr">Hausnr. <span className="required-star">*</span></label>
          <input
            id="uebertragungsberechtigte-hausnr"
            type="text"
            value={ub.hausnummer}
            onChange={(e) => handleUebertragungsberechtigtenChange(ub.id, 'hausnummer', e.target.value)}
            className={errors.ubHausnummer ? 'error' : ''}
            placeholder=""
            title="z.B. 12, 12a, 12/1, 12-1, 12–14"
            maxLength={10}
          />
          {renderFieldErrors('ubHausnummer')}
        </div>
      </div>

      <div className="form-row short-long">
        <div className="form-field">
          <label htmlFor="uebertragungsberechtigte-plz">Postleitzahl <span className="required-star">*</span></label>
          <input
            id="uebertragungsberechtigte-plz"
            type="text"
            value={ub.postleitzahl}
            onChange={(e) => handleUebertragungsberechtigtenChange(ub.id, 'postleitzahl', e.target.value)}
            className={errors.ubPlz ? 'error' : ''}
            maxLength="5"
            placeholder=""
            title="z.B. 33100"
          />
          {renderFieldErrors('ubPlz')}
        </div>
        <div className="form-field">
          <label htmlFor="uebertragungsberechtigte-ort">Ort <span className="required-star">*</span></label>
          <input
            id="uebertragungsberechtigte-ort"
            type="text"
            value={ub.ort}
            onChange={(e) => handleUebertragungsberechtigtenChange(ub.id, 'ort', e.target.value)}
            className={errors.ubOrt ? 'error' : ''}
            placeholder=""
            title="Paderborn"
            maxLength={100}
          />
          {renderFieldErrors('ubOrt')}
        </div>
      </div>
    </div>
  );
};

export default UebertragungsberechtigteForm;
